module.exports = __webpack_public_path__ + "img/bs-6.63068c51.jpg";